import React from "react";
import { Montserrat } from "next/font/google";
import { IconButton, Tooltip } from "@mui/material";
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useTranslations } from "next-intl";
const montserrat = Montserrat({
    subsets: ["latin"],
});

interface ExitFullScreenProps {
    onExitFullscreen?: () => void;
}
const ExitFullScreen = ({ onExitFullscreen } : ExitFullScreenProps) => {
    const t = useTranslations("messages");
    return (
        <Tooltip
            title={<span className={`${montserrat.className}`} translation-key="report_content_exit_fullscreen">
                {t("report_content_exit_fullscreen")}
            </span>}
            placement="top"
        >
            <IconButton
                onClick={onExitFullscreen}
                className="!absolute !bottom-4 !right-4 md:!bottom-5 md:!right-5 !bg-white !shadow-md !rounded-full !w-10 !h-10 md:!w-12 md:!h-12 !z-50"
                aria-label={t("report_content_exit_fullscreen")}
            >
                <FullscreenExitIcon className="text-gray-800 w-5 h-5 md:w-6 md:h-6" />
            </IconButton>
        </Tooltip>
    )
};

export default ExitFullScreen;